import { Signal } from '@preact/signals';
import type { WatchdogCountData } from 'service/watchdog/model.ts';
import { getWatchdogsCounts } from 'service/watchdog/resource';

export type WatchdogsSignalType = { data: WatchdogCountData[]; isLoading?: boolean };

export const DEFAULT_WATCHDOGS_VALUE: WatchdogsSignalType = {
	data: [],
};

export class WatchdogsSignal extends Signal<WatchdogsSignalType> {
	constructor(value: WatchdogsSignalType | undefined) {
		super(value);
	}

	remove(watchdogId: number) {
		this.value = { ...this.value, data: this.value.data.filter((watchdog) => watchdog.id !== watchdogId) };
	}

	async refreshWatchdogRemotely(watchdogId: number) {
		try {
			const watchdogIndex = this.peek().data.findIndex((watchdog) => watchdog.id === watchdogId);
			const oldWatchdog = this.peek().data[watchdogIndex];

			if (oldWatchdog) {
				const refreshedWatchdogs = await getWatchdogsCounts();
				this.value = { data: refreshedWatchdogs };
			}
		} catch (error) {
			console.error(error);
		}
	}
}

export const watchdogs = new WatchdogsSignal(undefined);
